import React from 'react';

export function WarningIcon(props: any) {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.41176 7.76471H6.58824V8.94118H5.41176V7.76471ZM5.41176 3.05882H6.58824V7.05882H5.41176V3.05882ZM6 12C4.39718 12 2.89035 11.3758 1.75741 10.2426C0.624 9.10941 0 7.60259 0 6C0 2.69153 2.69153 -4.47035e-08 6 -4.47035e-08H6.00094C7.60329 -4.47035e-08 9.10988 0.624236 10.2433 1.75741C11.3758 2.89059 12 4.39741 12 6C12 9.30847 9.30847 12 6 12ZM9.44353 2.55671C8.99255 2.1032 8.45608 1.74367 7.8652 1.49891C7.27431 1.25416 6.64074 1.12905 6.00118 1.13082H6C3.31529 1.13082 1.13059 3.31506 1.13059 6C1.12884 6.6397 1.25396 7.2734 1.49871 7.86444C1.74346 8.45547 2.10298 8.99211 2.55647 9.44329C3.00768 9.89684 3.54434 10.2564 4.13542 10.5012C4.72649 10.746 5.36024 10.8711 6 10.8694C8.68471 10.8694 10.8694 8.68494 10.8694 6C10.8711 5.3603 10.746 4.7266 10.5013 4.13557C10.2565 3.54454 9.89701 3.0079 9.44353 2.55671V2.55671Z"
        fill="#91A2AE"
      />
    </svg>
  );
}
